import {request} from '@/lib/request'

function contentPath(locale) {
  return `${process.env.BASE_URL}data/i18n/${locale}.json`
}

export function getContent(locale) {
  const url = contentPath(locale)
  const method = 'GET'

  return request({url, method}).then(({response}) => {
    return JSON.parse(response)
  })
}

export function t(store, key, replacements = []) {
  const string = store.getters.localised(key)

  if (replacements.length) {
    return replacements.reduce((accumulator, currentValue) => {
      return accumulator.replace('?', currentValue)
    }, string)
  }

  return string
}

export function hasT(store, key) {
  return !!store.getters.hasLocalisation(key)
}
